import script from "./StepButtonGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepButtonGrid.vue?vue&type=script&setup=true&lang=ts"

import "./StepButtonGrid.vue?vue&type=style&index=0&id=66537051&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66537051"]])

export default __exports__